'use client';

import React from 'react';
import { X, Check, ArrowRight, TrendingDown } from "lucide-react";
import Link from 'next/link';

const PainPoints = () => {
  const competitors = [
    {
      name: "Surfer SEO",
      price: "$59/mo",
      problem: "No AI search optimization",
    },
    {
      name: "Jasper AI",
      price: "$49/mo",
      problem: "No real-time analytics",
    },
    {
      name: "Most SEO Tools",
      price: "$99+/mo",
      problem: "Ignore AI search traffic",
    }
  ];

  const solution = {
    features: [
      "Real competitor keyword data",
      "Auto-indexed in Bing for AI search",
      "Real-time analytics dashboard",
      "One-click GitHub publishing",
      "Built-in internal linking",
      "AI content generation"
    ],
    price: "$19.99/mo"
  };

  return (
    <section className="py-12 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header - More subtle */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-3 py-1.5 rounded-full text-sm font-medium mb-3">
            <TrendingDown className="w-4 h-4" />
            Compare & Save
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Why Indie Makers Are Switching
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Get more features for less. Here's what you're actually paying for with expensive tools:
          </p>
        </div>

        {/* Competitors - Subtle red accents */}
        <div className="grid md:grid-cols-3 gap-4 mb-8">
          {competitors.map((competitor, index) => (
            <div
              key={index}
              className="bg-gray-50 border border-red-300 rounded-lg p-5 hover:border-red-200 transition-colors"
            >
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-1">
                    {competitor.name}
                  </h3>
                  <p className="text-xl font-bold text-gray-900">
                    {competitor.price}
                  </p>
                </div>
                <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center">
                  <X className="w-4 h-4 text-red-600" />
                </div>
              </div>
              <p className="text-sm text-gray-600">
                {competitor.problem}
              </p>
            </div>
          ))}
        </div>

        {/* Arrow - Minimal */}
        {/* <div className="flex justify-center mb-6">
          <div className="text-emerald-600 font-medium text-sm flex items-center gap-2">
            A better way
            <ArrowRight className="w-4 h-4" />
          </div>
        </div> */}

        {/* Solution - Clean and elegant */}
        <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-200 rounded-xl p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-6">
            <div>
              <div className="inline-flex items-center gap-2 bg-emerald-600 text-white px-3 py-1 rounded-md text-sm font-semibold mb-3">
                <Check className="w-4 h-4" />
                SEOZast
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                All Features + AI Search
              </h3>
              <p className="text-gray-700">
                Everything you need. Nothing you don't.
              </p>
            </div>
            
            <div className="text-left md:text-right">
              <div className="text-4xl md:text-5xl font-bold text-emerald-600 mb-1">
                {solution.price}
              </div>
              <p className="text-gray-600 text-sm">
                For less than a coffee per article
              </p>
            </div>
          </div>

          {/* Features - Compact grid */}
          <div className="grid md:grid-cols-2 gap-3 mb-6">
            {solution.features.map((feature, index) => (
              <div key={index} className="flex items-center gap-2 text-sm">
                <div className="w-5 h-5 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 text-white" />
                </div>
                <p className="text-gray-800 font-medium">
                  {feature}
                </p>
              </div>
            ))}
          </div>

          {/* CTA - Cleaner */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              href="/register"
              className="inline-flex items-center justify-center bg-emerald-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-emerald-700 transition duration-300"
            >
              Start Free Now
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
            <Link
              href="/#pricing"
              className="inline-flex items-center justify-center font-semibold py-3 px-6 rounded-lg text-emerald-700 border border-emerald-300 hover:bg-emerald-50 transition duration-300"
            >
              See Full Pricing
            </Link>
          </div>

          {/* Trust line - Subtle */}
          <div className="mt-4 text-center sm:text-left">
            <p className="text-xs text-gray-600">
              No credit card required • Cancel anytime • 200+ happy users
            </p>
          </div>
        </div>

        {/* Bottom savings note - Understated */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            💡 Save $600+/year compared to traditional SEO tools
          </p>
        </div>
      </div>
    </section>
  );
};

export default PainPoints;